import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EmployeesRoutingModule } from './employees-routing.module';
import { BenefitsComponent } from './benefits/benefits.component';
import { ExchangeBenefitsComponent } from './exchange-benefits/exchange-benefits.component';
import { EmployeeListComponent } from './employee-list/employee-list.component';
import { EmployeesComponent } from './employees/employees.component';
import { SharedModule } from '../../../../shared/shared.module';
import { EmployeeService } from '../../../../shared/_services/employee.service';
import { NewBenefitComponent } from './new-benefit/new-benefit.component';
import { EmployeeDetailsComponent } from './employee-details/employee-details.component';
import { EmployeeTransactionHistoryComponent } from './employee-transaction-history/employee-transaction-history.component';
import { EmployeeGuestBookingComponent } from './employee-guest-booking/employee-guest-booking.component';
import { EmployeeExchangeBenefitsComponent } from './employee-exchange-benefits/employee-exchange-benefits.component';
import { EmployeeCommentsComponent } from './employee-comments/employee-comments.component';
import { ExchangeBenefitsDetailsComponent } from './exchange-benefits-details/exchange-benefits-details.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    EmployeesRoutingModule
  ],
  declarations: [EmployeesComponent, BenefitsComponent, ExchangeBenefitsComponent, EmployeeListComponent, NewBenefitComponent, EmployeeDetailsComponent, EmployeeTransactionHistoryComponent, EmployeeGuestBookingComponent, EmployeeExchangeBenefitsComponent, EmployeeCommentsComponent, ExchangeBenefitsDetailsComponent],
  providers: [EmployeeService]
})
export class EmployeesModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/employees/employees.module.ts